module.exports = __webpack_public_path__ + "img/sne.75239e9c.jpg";